import { useState, useEffect } from 'react'

interface BreakPoint {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export const useResponsive = (): BreakPoint => {
  const [breakpoint, setBreakpoint] = useState<BreakPoint>({
    isMobile: false,
    isTablet: false,
    isDesktop: false, // 초기에는 모두 false로 설정
  })

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth
      const updatedBreakpoint = {
        isMobile: width <= 767,
        isTablet: width >= 768 && width <= 1023,
        isDesktop: width >= 1024,
      }

      //console.log('📱 현재 화면 너비:', width)
      //console.log('✅ 반응형 상태:', updatedBreakpoint)

      setBreakpoint(updatedBreakpoint)
    }

    updateSize()
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return breakpoint
}
